export enum ErrorCode {
    BadRequest = 'BAD_REQUEST_ERROR',
    NotAcces = 'NOT_ACCESS_ERROR',
    NotFound = 'NOT_FOUND_ERROR',
    RequestTimeout = 'REQUEST_TIMEOUT_ERROR',
    ServerError = 'SERVER_ERROR',
    ServiceUnavailable = 'SERVICE_UNAVAILABLE_ERROR',
    GatawayTimeout = 'GATAWAY_TIMEOUT_ERROR',
    Conflict = 'CONFLICT_ERROR',
    WebviewInit = 'WEBVIEW_INIT_ERROR',
    UpdateToken = 'UPDATE_TOKEN_ERROR',
    InitContext = 'INIT_CONTEXT_ERROR',
}
